(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slv-proyeccion"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const iniciar = (raiz) => {
      if (raiz.dataset.slvListo) return;
      raiz.dataset.slvListo = '1';
      const diapos = [...raiz.querySelectorAll('.slv-proy__diapo')];
      const disco = raiz.querySelector('.slv-proy__disco');
      const palabras = raiz.querySelector('[data-slv-palabras]');
      if (diapos.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      let i = 0, reloj = null;
      const siguiente = () => {
        const actual = diapos[i];
        i = (i + 1) % diapos.length;
        const nueva = diapos[i];
        disco.classList.remove('is-cambiando'); void disco.offsetWidth; disco.classList.add('is-cambiando');
        actual.classList.remove('is-activa');
        nueva.classList.add('is-activa');
        if (palabras) {
          palabras.classList.add('is-saliendo');
          setTimeout(() => { palabras.textContent = nueva.dataset.palabras; palabras.classList.remove('is-saliendo'); }, 350);
        }
      };
      const arrancar = () => { if (!reloj) reloj = setInterval(siguiente, 3400); };
      const parar = () => { clearInterval(reloj); reloj = null; };
      new IntersectionObserver((e) => e[0].isIntersecting ? arrancar() : parar(), { threshold: 0.35 }).observe(raiz);
      document.addEventListener('visibilitychange', () => document.hidden && parar());
    };
    const todas = () => document.querySelectorAll('[data-slv-proy]').forEach(iniciar);
    todas();
    document.addEventListener('shopify:section:load', todas);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slv-tarjetas"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ver = () => document.querySelectorAll('[data-slv-tarj]:not(.is-visible)').forEach((s) => {
      if (!('IntersectionObserver' in window) || s.classList.contains('slv-anim')) return;
      s.classList.add('slv-anim');
      const io = new IntersectionObserver((e) => { if (e[0].isIntersecting) { s.classList.add('is-visible'); io.disconnect(); } }, { threshold: 0.15 });
      io.observe(s);
    });
    ver();
    document.addEventListener('shopify:section:load', ver);
  })();

  } catch(e) { console.error(e); }
})();
})();
